import { systemSetAppConfig, systemSetInitDone, systemToggleDarkTheme } from "./system/action";

const actions = {
    system: {
        toggleDarkTheme: systemToggleDarkTheme,
        setAppConfig: systemSetAppConfig,
        setInitDone: systemSetInitDone,
    }
};

export { actions };
